/**
 * Checks if the value contains only English digits and an optional decimal point.
 * @param {string|number} value
 * @returns {boolean}
 */
export const isEnglishNumber = (value) => {
  if (!value) return true;
  return /^\d*\.?\d*$/.test(value);
};

/**
 * Validates that the integer part (digits before the decimal) is 8 characters or less.
 * @param {string|number} value
 * @returns {boolean}
 */
export const maxInteger8 = (value) => {
  if (!value) return true;
  const integerPart = value.toString().split('.')[0];
  return integerPart.length <= 8;
};

/**
 * Validates that there are no more than two digits after the decimal point.
 * @param {string|number} value
 * @returns {boolean}
 */
export const decimalWithTwoPlaces = (value) => {
  if (!value) return true;
  if (!value.toString().includes('.')) return true;
  const decimalPart = value.toString().split('.')[1];
  return decimalPart.length <= 2;
};

/**
 * Prevents invalid characters for numeric input (e, E, +, -, 0).
 * Intended to be used on keydown events.
 *
 * @param {KeyboardEvent} event
 * @returns {void}
 */
export const blockSpecialChars = (event) => {
  const forbiddenKeys = ['e', 'E', '+', '-',];
  if (forbiddenKeys.includes(event.key)) {
    event.preventDefault();
  }
};
